// extracted by mini-css-extract-plugin
export default {"labelFont":"500 14px Roboto,sans-serif","emptyLabelFont":"14px Roboto,sans-serif"};